import { Spinner } from "reactstrap";
export const Loading = ({ className }) => {
  return <Spinner className={className} />;
};
